import { createContext } from "react";

export interface ExpandableSectionContextType {
	expanded: boolean;
	keepMounted: boolean;
	toggle: () => void;
}

export const ExpandableSectionContext = createContext<ExpandableSectionContextType | undefined>(undefined);
